// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  flex-direction: row;
  justify-content: flex-start;
  display: flex;
  padding-bottom: 15px;
}

.drop-down {
  margin-right: 11px;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.search-actions {
  height: -moz-fit-content;
  height: fit-content;
}

.actions {
  height: 35px;
  align-items: center;
  padding-right: 10px;
}

.search-options {
  margin-right: 11px;
}

.label {
  margin-right: 11px;
  color: var(--theme-main-color, #055C8D);
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.305883px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 60px;
}

.advanced-search-container {
  margin-top: 2px;
  margin-left: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
